export default __webpack_public_path__ + "static/project-slide-1-1640-765-bc9c03a95ead263e175386672ad96e1d.webp";